var _style, _path, _g, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPirAntimasking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.1 16.2",
    style: {
      enableBackground: "new 0 0 16.1 16.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3,13.2c2.5,1.9,5.5,2.8,8.6,2.6c2.5-0.1,4.9-1,6.9-2.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "4.7,10.7 3.6,14 5.9,14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8,10.7 6.9,14 9.2,14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.4,10.7 10.2,14 12.5,14  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "8,0.8 3.7,9.1 12.4,9.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirAntimasking);
export default __webpack_public_path__ + "static/media/PIRAntimasking.832166499dd34728f997de08f75adc08.svg";
export { ForwardRef as ReactComponent };